import React, { useState } from 'react';
import type { MenuItem } from '../../types';

interface MeatOptionModalProps {
  item: MenuItem;
  onSelect: (item: MenuItem, selectedOption: string) => void;
  onCancel: () => void;
}

const MeatOptionModal: React.FC<MeatOptionModalProps> = ({ item, onSelect, onCancel }) => {
  const [selectedOption, setSelectedOption] = useState<string>('');

  const handleConfirm = () => {
    if (selectedOption) {
      onSelect(item, selectedOption);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4 overflow-y-auto" data-testid="meat-option-modal">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md max-h-[90vh] overflow-y-auto my-auto">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Select Option</h2>
        <p className="text-gray-600 mb-4">Choose an option for <strong>{item.name}</strong></p>
        
        <div className="space-y-2 mb-6">
          {item.meatOptions?.map((option) => (
            <button
              key={option}
              type="button"
              data-testid="meat-option-choice"
              onClick={() => setSelectedOption(option)}
              className={`w-full text-left px-4 py-3 rounded-lg border-2 transition-all ${
                selectedOption === option
                  ? 'border-pink-500 bg-pink-50 text-pink-800 font-semibold'
                  : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              {option}
            </button>
          ))}
        </div>

        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={onCancel}
            data-testid="meat-option-cancel"
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={!selectedOption}
            data-testid="meat-option-add"
            className={`px-4 py-2 rounded-md font-semibold ${
              selectedOption
                ? 'bg-pink-500 text-white hover:bg-pink-600'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Add to Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeatOptionModal;

